class NCUIInfiniteScroll {
  constructor(container) {
    this.container = container;
    this.observer = null;
    this.loading = false;
    this.finished = false;
  }

  init() {
    this.disconnect();
    this.sentinel = this.container.querySelector('#InfiniteScrollSentinel');
    if (!this.sentinel) return;
    this.finished = false;
    this.showSpinner(false);
    this.observer = new IntersectionObserver((entries) => this.handleIntersect(entries), {
      rootMargin: '300px 0px',
    });
    this.observer.observe(this.sentinel);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  handleIntersect(entries) {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    if (this.loading || this.finished) return;
    this.loadNextPage();
  }

  showSpinner(show) {
    if (!this.sentinel) return;
    const spinner = this.sentinel.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !show);
  }

  loadNextPage() {
    const nextUrl = this.sentinel.getAttribute('data-next-url');
    const sectionId = this.sentinel.getAttribute('data-section-id');
    if (!nextUrl || !sectionId) {
      this.finished = true;
      return;
    }

    this.loading = true;
    this.showSpinner(true);
    this.sentinel.setAttribute('aria-busy', 'true');

    const separator = nextUrl.includes('?') ? '&' : '?';
    const url = `${nextUrl}${separator}section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const grid = this.container.querySelector('#product-grid');
        const sourceGrid = parsed.getElementById('product-grid');
        if (grid && sourceGrid) {
          Array.from(sourceGrid.children).forEach((node) => grid.appendChild(node));
        }

        const nextSentinel = parsed.getElementById('InfiniteScrollSentinel');
        if (nextSentinel) {
          this.sentinel.setAttribute('data-next-url', nextSentinel.getAttribute('data-next-url') || '');
          this.sentinel.setAttribute(
            'data-section-id',
            nextSentinel.getAttribute('data-section-id') || sectionId,
          );
        } else {
          this.finished = true;
          if (this.sentinel) this.sentinel.remove();
        }
      })
      .catch((error) => {
        console.error('Infinite scroll error:', error);
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
        this.showSpinner(false);
        if (this.sentinel) this.sentinel.removeAttribute('aria-busy');
      });
  }
}

function initNCUIInfiniteScroll() {
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;

  if (!window.ncuiInfiniteScroll) {
    window.ncuiInfiniteScroll = new NCUIInfiniteScroll(container);
    new MutationObserver(() => initNCUIInfiniteScroll()).observe(container, {
      childList: true,
      subtree: true,
    });
  }

  window.ncuiInfiniteScroll.init();
}

document.addEventListener('DOMContentLoaded', initNCUIInfiniteScroll);
